<template>
  <div>
    <PCNavbar selectIndex="2"/>
    <!-- <MobileNavBar :currentActive="1" /> -->
    <Research />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Research from '@/components/research/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Research
  },
}
</script>

<style>
</style>